var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("layout-9", {
        staticStyle: { width: "100%", height: "calc(100vh - 50px)" },
        attrs: {
          id: _vm.pageid1,
          idTime: _vm.pageid2,
          idMaterial: _vm.pageid3,
          idPonumber: _vm.pageid4,
          idComplete: _vm.pageid5,
          idAddrs: _vm.pageid6,
          idHourCalc: _vm.pageid7,
          idMaterialRate: _vm.pageid8,
          idDocuments: _vm.pageid9,
          idAdditionaljoborders: _vm.pageid10,
          term: _vm.term
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6da37d0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da37d0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add/Add_Invoice_Prep.vue
// module id = 653
// module chunks = 0